import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import Texture from './texture';
import assert from '../utils/assert';
var FACES = [34069, 34070, 34071, 34072, 34073, 34074];

var TextureCube =
/*#__PURE__*/
function (_Texture) {
  _inherits(TextureCube, _Texture);

  function TextureCube(gl) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TextureCube);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextureCube).call(this, gl, Object.assign({}, opts, {
      target: 34067
    })));

    _this.initialize(opts);

    Object.seal(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /* eslint-disable max-len, max-statements */


  _createClass(TextureCube, [{
    key: "initialize",
    value: function initialize() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$format = opts.format,
          format = _opts$format === void 0 ? 6408 : _opts$format,
          _opts$mipmaps = opts.mipmaps,
          mipmaps = _opts$mipmaps === void 0 ? true : _opts$mipmaps;
      var _opts$width = opts.width,
          width = _opts$width === void 0 ? 1 : _opts$width,
          _opts$height = opts.height,
          height = _opts$height === void 0 ? 1 : _opts$height,
          _opts$type = opts.type,
          type = _opts$type === void 0 ? 5121 : _opts$type,
          dataFormat = opts.dataFormat; // Deduce width and height based on one of the faces

      var _this$_deduceParamete = this._deduceParameters({
        format: format,
        type: type,
        dataFormat: dataFormat
      });

      type = _this$_deduceParamete.type;
      dataFormat = _this$_deduceParamete.dataFormat;

      var _this$_deduceImageSiz = this._deduceImageSize({
        data: opts[34069],
        width: width,
        height: height
      });

      width = _this$_deduceImageSiz.width;
      height = _this$_deduceImageSiz.height;
      // Enforce cube
      assert(width === height); // Temporarily apply any pixel store paramaters and build textures
      // withParameters(this.gl, opts, () => {
      //   for (const face of CUBE_MAP_FACES) {
      //     this.setImageData({
      //       target: face,
      //       data: opts[face],
      //       width, height, format, type, dataFormat, border, mipmaps
      //     });
      //   }
      // });

      this.setCubeMapImageData(opts); // Called here so that GL.
      // TODO - should genMipmap() be called on the cubemap or on the faces?

      if (mipmaps) {
        this.generateMipmap(opts);
      } // Store opts for accessors


      this.opts = opts;
    }
  }, {
    key: "subImage",
    value: function subImage(_ref) {
      var face = _ref.face,
          data = _ref.data,
          _ref$x = _ref.x,
          x = _ref$x === void 0 ? 0 : _ref$x,
          _ref$y = _ref.y,
          y = _ref$y === void 0 ? 0 : _ref$y,
          _ref$mipmapLevel = _ref.mipmapLevel,
          mipmapLevel = _ref$mipmapLevel === void 0 ? 0 : _ref$mipmapLevel;
      return this._subImage({
        target: face,
        data: data,
        x: x,
        y: y,
        mipmapLevel: mipmapLevel
      });
    }
    /* eslint-disable max-statements, max-len */

  }, {
    key: "setCubeMapImageData",
    value: function setCubeMapImageData(_ref2) {
      var width = _ref2.width,
          height = _ref2.height,
          pixels = _ref2.pixels,
          data = _ref2.data,
          _ref2$border = _ref2.border,
          border = _ref2$border === void 0 ? 0 : _ref2$border,
          _ref2$format = _ref2.format,
          format = _ref2$format === void 0 ? 6408 : _ref2$format,
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? 5121 : _ref2$type,
          _ref2$generateMipmap = _ref2.generateMipmap,
          generateMipmap = _ref2$generateMipmap === void 0 ? false : _ref2$generateMipmap;
      var gl = this.gl;
      pixels = pixels || data;
      this.bind();

      if (this.width || this.height) {
        for (var _i = 0; _i < FACES.length; _i++) {
          var face = FACES[_i];
          gl.texImage2D(face, 0, format, width, height, border, format, type, pixels[face]);
        }
      } else {
        for (var _i2 = 0; _i2 < FACES.length; _i2++) {
          var _face = FACES[_i2];
          gl.texImage2D(_face, 0, format, format, type, pixels[_face]);
        }
      }
    }
  }, {
    key: "bind",
    value: function bind() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          index = _ref3.index;

      if (index !== undefined) {
        this.gl.activeTexture(33984 + index);
      }

      this.gl.bindTexture(34067, this.handle);
      return index;
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.gl.bindTexture(34067, null);
      return this;
    }
  }]);

  return TextureCube;
}(Texture);

export { TextureCube as default };
TextureCube.FACES = FACES;
//# sourceMappingURL=texture-cube.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/webgl/texture-cube.js
// module id = 354
// module chunks = 0